/* ── Before / After Slider ── */
(function () {
  function init(slider) {
    const handle = slider.querySelector('.lf-ba__handle');
    const before = slider.querySelector('.lf-ba__side--before');
    if (!handle || !before) return;

    let dragging = false;

    function setPosition(x) {
      const rect = slider.getBoundingClientRect();
      const pct  = Math.min(100, Math.max(0, ((x - rect.left) / rect.width) * 100));
      slider.style.setProperty('--lf-ba-position', pct + '%');
      before.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    slider.addEventListener('mousedown', (e) => { dragging = true; setPosition(e.clientX); });
    window.addEventListener('mouseup',   () => { dragging = false; });
    window.addEventListener('mousemove', (e) => { if (dragging) setPosition(e.clientX); });

    slider.addEventListener('touchstart', (e) => { dragging = true; setPosition(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend',   () => { dragging = false; });
    window.addEventListener('touchmove',  (e) => { if (dragging) setPosition(e.touches[0].clientX); }, { passive: true });

    handle.addEventListener('keydown', (e) => {
      const rect = slider.getBoundingClientRect();
      const cur  = parseFloat(slider.style.getPropertyValue('--lf-ba-position')) || 50;
      if (e.key === 'ArrowLeft')  setPosition(rect.left + (cur - 5) / 100 * rect.width);
      if (e.key === 'ArrowRight') setPosition(rect.left + (cur + 5) / 100 * rect.width);
    });

    // init clip
    const pos = parseFloat(slider.style.getPropertyValue('--lf-ba-position')) || 50;
    before.style.clipPath = `inset(0 ${100 - pos}% 0 0)`;
  }

  function initAll() {
    document.querySelectorAll('[data-lf-before-after]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
